import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getInvoiceList = createAsyncThunk(
  "get-invoice",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("invoice/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getInvoiceNo = createAsyncThunk(
  "get-invoice-no",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get("invoice/get-number");
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createInvoice = createAsyncThunk(
  "create-invoice",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("invoice", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editInvoice = createAsyncThunk(
  "edit-invoice",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`invoice/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateInvoice = createAsyncThunk(
  "update-invoice",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/invoice/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  "delete-invoice",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/invoice/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.invoiceList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getInvoiceList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default invoiceSlice.reducer;
